import type * as Types from 'app/types/graphql';

import { PlanEdgeSelectFragmentDoc, PlanSelectFragmentDoc } from '../fragments/plan.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PlansQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where?: Types.InputMaybe<Types.PlanWhereInput>;
}>;

export type PlansQueryResponse = {
  plans?: Types.Maybe<{
    edges?: Types.Maybe<
      Array<
        Pick<Types.PlanEdge, 'cursor'> & {
          node?: Types.Maybe<
            Pick<
              Types.Plan,
              | 'id'
              | 'name'
              | 'displayName'
              | 'priority'
              | 'isTrial'
              | 'basePrice'
              | 'billingCycle'
              | 'deprecated'
              | 'conditions'
              | 'createdAt'
              | 'updatedAt'
              | 'trialDays'
            >
          >;
        }
      >
    >;
  }>;
};

export const PlansDocument = `
    query Plans($first: Int, $where: PlanWhereInput) {
  plans(first: $first, where: $where) {
    edges {
      ...PlanEdgeSelect
    }
  }
}
    ${PlanEdgeSelectFragmentDoc}
${PlanSelectFragmentDoc}`;

export const usePlansQuery = <TData = PlansQueryResponse, TError = unknown>(
  variables?: PlansQueryVariables,
  options?: UseQueryOptions<PlansQueryResponse, TError, TData>,
) => {
  return useQuery<PlansQueryResponse, TError, TData>(
    variables === undefined ? ['Plans'] : ['Plans', variables],
    appFetcher<PlansQueryResponse, PlansQueryVariables>(PlansDocument, variables),
    options,
  );
};

usePlansQuery.getKey = (variables?: PlansQueryVariables) =>
  variables === undefined ? ['Plans'] : ['Plans', variables];
